/* eslint-disable dot-notation */
import _, { orderBy } from 'lodash';
import EventBus from 'eventing-bus';
import Pagination from 'rc-pagination';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { Button, Col, Input, InputGroup, InputGroupAddon, Row } from 'reactstrap';
import { addStep, popStep } from '../../../actions/Breadcrumbs';
import { getCompanies, getAllCompanyGroups } from '../../../actions/Companies';
import {
  addNote,
  cancelCreateEpikBox,
  cancelDeleteEpikBox,
  cancelUpdateEpikBox,
  clearEpikBoxesData,
  createEpikBox,
  deleteEpikBox,
  deleteNote,
  downloadAttachment,
  editNote,
  epikBoxesCompanyFilter,
  advanceLocalArray,
  filterByStatus,
  getBoxCount,
  getEpikBoxesData,
  getEpikBoxesDataByName,
  getEpikBoxesByAdSearch,
  bulkAssignEpikBox,
  getEpikBoxesDataByObi,
  getEpikBoxesBySerialNumber,
  getEpikBoxesByFavorites,
  getEpikBoxesByMacAddress,
  getEpikBoxesByStatus,
  getEpikBoxesByAssignedNumber,
  getEpikBoxesByTrackingNumber,
  getEpikBoxesByVPNAddress,
  getEpikBoxesDetail,
  getNotes,
  importEpikBox,
  onRecover,
  setBoxDetailsData,
  setBoxMonitorToggleState,
  showCreateEpikBox,
  showDeleteEpikBox,
  showUpdateEpikBox,
  updateEpikBox,
  getLocationByCompany,
  getEpikBoxesDataByLocation,
  getEpikUnassignedBoxesData,
  getEpikBoxLocations,
  filteredLocationBoxes,
  mapLocationsFilter,
  setBoxPagination,
  clearBoxPagination,
  getBoxesByGroupIDAction,
  onDeleteRecording,
  getEpikBoxesByIMEI,
  getEpikBoxesBySIM,
  getEpikBoxesByCreated,
} from '../../../actions/EpikBoxes';
import AddNotesList from '../../../components/AddNotesList';
import Breadcrumbs from '../../../components/Breadcrumb';
import CompanyAutocomplete from '../../../components/CompanyAutocomplete';
import DeleteBoxModal from '../../../components/DeleteBoxModal';
import EpikBoxesList from '../../../components/EpikBoxes/BoxList/EpikBoxesList';
import EpikBoxesTable from '../../../components/EpikBoxes/BoxList/EpikBoxesTable';
import ImportEpikBoxModal from '../../../components/ImportEpikBoxModal';
import NewEpikboxModal from '../../../components/NewEpikboxModal';
import BulkBoxAssignmentModal from '../../../components/BulkBoxAssignmentModal';
import SetLimitEntries from '../../../components/SetLimitEntries';
import UpdateEpikBoxModal from '../../../components/EpikBoxes/UpdateEpikBoxModal';
import WithUserData from '../../../HOC/withUserData';
import filterIcon from '../../../Res/Icon/filter.png';
import { ReactComponent as Favorite } from '../../../Res/svg/favorite.svg';
import './epikBoxes.css';
import LocationDetails from '../../../components/LocationDetails';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import EpikBoxesMap from '../../../components/EpikBoxes/BoxList/EpikBoxesMap';
import { toast } from 'react-toastify';
import { sendBulkActionsToApi } from '../../../actions/BoxSessionLogging';
import { ENG_LOCALE } from '../../../lib/constants';
import CustomModal from '../../../components/CustomModal';
import AdvanceSearchBody from '../../../components/EpikBoxes/EpikBoxDetails/AdvanceSearch/AdvanceSearchBody';
import RecentSearches from '../../../components/EpikBoxes/EpikBoxDetails/RecentSearches/RecentSearches';
import { addSystemLogs } from '../../../actions/SystemLogs';
import { ProgressIndicator } from '../../../components/ProgressIndicator';
import { DateRangePicker } from 'react-bootstrap-daterangepicker';
import FavoriteBoxes from '../../../components/EpikBoxes/EpikBoxDetails/Favorites/FavoriteBoxes';

const tab = 'none';
const filterStatusOptions = ['All', 'Registered', 'UnRegistered'];
class EpikBoxes extends Component {
  constructor(props) {
    super(props);
    this.token = localStorage.getItem('jwtToken') || null;
    this.onCompanyFilter = this.onCompanyFilter.bind(this);
    this.state = {
      selectedBox: null,
      dropdownOpen: false,
      selectedFilter:
        props.user.role === 'admin' ||
          props.user.company.companyType === 'manufacturer'
          ? 'Edge Device'
          : 'Company',
      obiNumberFilter: '',
      importModal: false,
      BulkBoxAssignmentModal: false,
      disableCompany: false,
      filterApplied: true,
      locationStatus: false,
      locationSelect: false,
      selectedLocationId: '',
      statusFilterValue: 'All',
      sort: {
        name: '',
        order: '',
      },
      assignedNumberFilter: '',
      vpnaddressFilter: '',
      viewMode: 'list',
      onSerialNumberSelect: false,
      enableBoxEdit: true,
      searchModalStatus: false,
      advanceArray: [],
      advanceParams: '',
      recentStatus: false,
      imeiNumber: '',
      simNumber: '',
      created: '',
      dbSort: { createdAt: -1 },
      onFavorites: false,
      favoritesModalStatus: false,

      serialNumberFilter: '',
      boxFilter: '',
      macAddressFilter: '',
      trackingNumber: '',
    };
  }

  async bulkAssign(value) {
    const companyName = value.companyName;
    delete value.companyName
    const res = await this.props
      .bulkAssignEpikBox(this.token, value)
      .catch(error => toast.error(error.response.data || 'Error Updating Boxes'));

    if (res) {
      const body = {
        actionType: 'system',
        description: `Bulk devices Assigned to ${companyName} `,
      };
      await this.props.addSystemLogs(this.token, body);
    }

    toast.success('Box Updated Successfully');
    this.setState({ BulkBoxAssignmentModal: false });
    this.props.clearEpikBoxes();
    await this.props.getEpikBoxesData(this.token, value.assignedTo, 'none', undefined, 'no');
  }

  sortColumnByKey = array => {
    const { sort } = this.state;
    if (sort.name.indexOf('[') !== -1) {
      const sortNameArr = sort.name.replace(/[\[\]']+/g, ' ').split(' ');
      return orderBy(
        array,
        [el => el?.Company[sortNameArr[1]]?.name?.toLowerCase()]
        [sort.order],
      );
    } else if (typeof array[0][sort.name] === 'string') {
      return orderBy(array, [el => el[sort.name].toLowerCase()], [sort.order]);
    } else {
      return orderBy(array, [el => el[sort.name]], [sort.order]);
    }
  };

  getWIP = comp => {
    return comp.docs.filter(company => {
      if (company.name === '_WIP_') {
        return company;
      } else {
        return this.props.user.company;
      }
    });
  };

  async componentDidMount() {
    // this.props.getAllBoxes(this.token);
    const { getCompanyGroupDropdownList } = this.props;
    const pagination = { page: 1, limit: 10 };
    this.props.cancelCreateEpikBox();
    this.props.cancelUpdateEpikBox();
    this.props.cancelDeleteEpikBox();
    await getCompanyGroupDropdownList(this.token, null, false, true);

    EventBus.on('updateBoxesData', this.updateBoxesData);
    const {
      user,
      getEpikBoxesDetail,
      getEpikBoxLocations,
      getCompanies,
      setCompanyFilter,
      companyFilter,
    } = this.props;
    if (
      user.company.companyType !== 'manufacturer' &&
      (user.role === 'superAdmin' ||
        user.role === 'supportEngineer' ||
        user.role === 'companyGroupAdmin' ||
        user.role === 'companyGroupManager')
    ) {
      if (
        companyFilter?.value !== undefined &&
        companyFilter?.value !== '' &&
        companyFilter?.value !== null
      ) {
        this.companyID = companyFilter.suggestion._id;
        if (this.companyID) {
          localStorage.setItem('companyFilter', companyFilter.suggestion._id);
        }
      }
      await getEpikBoxesDetail(this.token, undefined, pagination);
      await getCompanies(this.token, undefined, 'yes', true);
    } else {
      const res = await getCompanies(this.token, undefined, 'yes', true);
      var compDetail = user.company;

      if (res) {
        compDetail = this.getWIP(res)[0];
      }

      this.companyID = compDetail._id;
      await getEpikBoxesDetail(this.token, compDetail._id, pagination);
      await getCompanies(this.token, undefined, 'yes', true);
      setCompanyFilter({ suggestion: { ...compDetail } });
      await this.props.getEpikBoxesData(this.token, this.companyID, 'none');
      this.props.getBoxCount(this.token, this.companyID);
    }
    if (global.boxDetailStatus) {
      this.companyID = localStorage.getItem('companyFilter');
      this.CompfilterApplied = true;
      this.setState({
        filterApplied: false,
      });
      global.boxDetailStatus = false;
    }
    await getEpikBoxLocations(this.token);
    // await this.updateBoxesData();
  }

  handleSortBoxes = async filter => {
    const { sort } = this.state;
    const { getEpikBoxesDetail, companyFilter } = this.props;
    const updateSort = { ...sort };
    const pagination = { page: 1, limit: 10 };
    this.companyID = companyFilter?.suggestion?._id;

    if (updateSort.name === filter) {
      updateSort.order = updateSort.order === 'asc' ? 'desc' : 'asc';
    } else {
      updateSort.name = filter;
      updateSort.order = 'asc';
    }

    const dbColNames = {
      boxName: 'boxName',
      lastUpdated: 'lastUpdated',
      ports: 'ports',
      'Company[0][name]': 'Company.name',
      total: 'total',
      online: 'online',
      offline: 'offline',
      unmonitored: 'unmonitored',
    };

    const sortQuery = {
      [dbColNames[(updateSort?.name)]]: updateSort?.order === 'asc' ? 1 : -1,
    };
    await getEpikBoxesDetail(this.token, this.companyID, {
      ...pagination,
      sort: sortQuery,
    });
    // token, companyId, online, unmonitored, disablePagination, pagination
    this.setState({ sort: updateSort, dbSort: sortQuery });
  };

  onAssignBoxPress = async () => {
    await this.props.getEpikUnassignedBoxesData(this.token);
    this.props.showCreateEpikBox();
  };

  updateBoxesData = async (companyId = '', resetPage = false) => {
    if (!this?.props.user || !this?.props.boxPagination || !this?.props.companyFilter) return;

    let { user, boxPagination, companyFilter } = this.props;
    if (!boxPagination?.sort) boxPagination.sort = { ...this.state.dbSort };
    if (resetPage) boxPagination = { page: 1, limit: 10 };

    const unmonitored = false;
    if (!user || !user.company) {
      return;
    }
    if (
      user.company.companyType !== 'manufacturer' &&
      (user.role === 'superAdmin' ||
        user.role === 'supportEngineer' ||
        user.role === 'companyGroupAdmin' ||
        user.role === 'companyGroupManager')
    ) {
      await this.props.getCompanies(this.token, undefined, 'yes', true);
      const companyID =
        companyId ||
        (this.props.companyFilter.suggestion && this.props.companyFilter.suggestion._id);
      if (!companyID && this.props.companyFilter.suggestion?.value) {
        if (this.props.companyFilter.suggestion.name === 'boxNameFilter') {
          await this.props.getEpikBoxesDataByName(
            this.token,
            this.props.companyFilter.suggestion?.value,
            tab,
            boxPagination,
          );
          await this.getMapLocations('boxname', this.props.companyFilter.suggestion?.value);
        } else {
          if (this.state.selectedFilter === 'EPI Number') {
            await this.props.getEpikBoxesDataByObi(
              this.token,
              this.state.obiNumberFilter,
              tab,
              boxPagination,
            );
            await this.getMapLocations('obiNumber', this.state.obiNumberFilter);
          } else if (this.state.selectedFilter === 'Assigned Number') {
            await this.props.getEpikBoxesByAssignedNumber(
              this.token,
              this.state.assignedNumberFilter,
              tab,
              boxPagination,
            );
            await this.getMapLocations('assignedNumber', this.state.assignedNumberFilter);
          } else if (this.state.selectedFilter === 'VPN Address') {
            await this.props.getEpikBoxesByVPNAddress(
              this.token,
              this.state.vpnaddressFilter,
              boxPagination,
            );
            await this.getMapLocations('vpnAddress', this.state.vpnaddressFilter);
          } else if (this.state.selectedFilter === 'Serial Number') {
            await this.props.getEpikBoxesBySerialNumber(
              this.token,
              this.state.serialNumberFilter,
              tab,
              boxPagination,
            );
            await this.getMapLocations('serialNumber', this.state.serialNumberFilter);
          } else if (this.state.selectedFilter === 'Mac Address') {
            await this.props.getEpikBoxesByMacAddress(
              this.token,
              this.state.macAddressFilter,
              tab,
              boxPagination,
            );
            await this.getMapLocations('macAddress', this.state.macAddressFilter);
          } else if (this.state.selectedFilter === 'Status') {
            this.statusFilter(this.state.statusFilterValue);
          } else if (this.state.selectedFilter === 'advanceFilter') {
            await this.props.getEpikBoxesByAdSearch(
              this.token,
              this.state.advanceParams,
              boxPagination,
            );
          } else if (this.state.selectedFilter === 'Favorites') {
            await this.props.getEpikBoxesByFavorites(this.token, tab, boxPagination);
          }
        }
      } else if (!companyID) {
        this.props.clearEpikBoxes();
      } else {
        if (this.state.filterApplied && !this.state.locationSelect) {
          if (this.state.selectedFilter === 'By Group') {
            await this.props.getBoxesByGroupID(this.token, companyID, boxPagination);
          } else {
            await this.props.getEpikBoxesData(
              this.token,
              companyID,
              'none',
              undefined,
              'no',
              boxPagination,
            );
          }
          if (this.props.user.role !== 'companyGroupAdmin') {
            //temporary check - to remove
            await this.getMapLocations('company', companyID);
          }
        } else if (this.state.filterApplied && this.state.locationSelect) {
          await this.props.getEpikBoxesDataByLocation(
            this.token,
            this.state.selectedLocationId,
            companyID,
            boxPagination,
          );
        } else {
          await this.props.getEpikBoxesData(
            this.token,
            companyID,
            'none',
            unmonitored,
            'no',
            boxPagination,
          );
          await this.getMapLocations('company', companyID);
        }
        // this.props.getBoxCount(this.token, companyID);
      }
    } else {
      await this.props.getEpikBoxesData(
        this.token,
        this.props.user.company._id,
        'none',
        unmonitored,
        'no',
        boxPagination,
      );
      this.props.getBoxCount(this.token, this.props.user.company._id);
      this.props.setCompanyFilter({ suggestion: { ...user.company } });
      await this.getMapLocations('company', this.props.user.company._id);
    }
  };

  getMapLocations = async (type, value) => {
    const { mapLocationsFilter } = this.props;
    await mapLocationsFilter(this.token, type, value);
  };

  onCompanyFilter = async (company, type) => {
    const { sort, viewMode } = this.state;
    const {
      addStep,
      getBoxCount,
      setCompanyFilter,
      getLocationByCompany,
      getEpikBoxesData,
      clearBoxPagination,
    } = this.props;
    const updateSort = { ...sort };
    updateSort.name = '';
    updateSort.order = '';
    await clearBoxPagination();
    this.setState({ sort: updateSort });
    if (company.suggestion !== null) {
      addStep({ label: company.suggestion.name, redirect: 'goBack', type: 'company' });
      localStorage.setItem('companyFilter', company.suggestion._id);
      this.companyID = company.suggestion._id;
      getBoxCount(this.token, company.suggestion._id);
      setCompanyFilter(company);
      getLocationByCompany(this.token, company.suggestion._id);

      if (type === 'searchBox') {
        this.setState({ filterApplied: true, locationStatus: true, locationSelect: false });
        await getEpikBoxesData(this.token, company.suggestion._id, 'none', undefined, 'no', null, true);
        await this.getMapLocations('company', company.suggestion._id);
      } else {
        await getEpikBoxesData(this.token, company.suggestion._id, 'none', undefined, 'no');
        await this.updateBoxesData(company.suggestion._id, true);
      }
    } else {
      this.props.setCompanyFilter({});
      this.setState({ filterApplied: false, locationStatus: false });
    }
  };

  handleFilterByGroupID = async e => {
    const { getBoxesByGroupID, setCompanyFilter } = this.props;
    const paginationOptions = { page: 1, limit: 10 };
    if (e?.suggestion !== null) {
      this.setState({ filterApplied: true, locationStatus: true });
      setCompanyFilter({ ...e });
      await getBoxesByGroupID(this.token, e?.suggestion._id, paginationOptions);
    } else {
      setCompanyFilter({});
      this.setState({ filterApplied: false, locationStatus: false });
    }
  };

  locationFilter = async location => {
    await this.props.getEpikBoxesDataByLocation(this.token, location._id, location.company);
    this.setState({ locationSelect: true, selectedLocationId: location._id });
  };

  selectLocation = async ({ location, boxes, locationCompany }) => {
    const { viewMode } = this.state;
    const { filteredLocationBoxes, setCompanyFilter } = this.props;
    filteredLocationBoxes(boxes);
    let data = {};
    data['name'] = 'boxNameFilter';
    data['value'] = locationCompany;
    data['suggestion'] = {};
    data['suggestion']['name'] = 'boxNameFilter';
    data['suggestion']['value'] = locationCompany;

    setCompanyFilter(data);
    this.setState({ locationSelect: true, selectedLocationId: location._id, viewMode: 'list' });
    if (viewMode === 'map' && boxes.length && boxes.length === 1) {
      this.onBoxClick(boxes[0]);
    }
  };

  onBoxFilter = async box => {
    const tab = 'none';
    const data = {};
    if (box) {
      data['name'] = 'boxNameFilter';
      data['value'] = box;
      data['suggestion'] = {};
      data['suggestion']['name'] = 'boxNameFilter';
      data['suggestion']['value'] = box;
      this.props.clearBoxPagination();
      this.props.getEpikBoxesDataByName(this.token, box, tab);
      this.props.setCompanyFilter(data);
      await this.getMapLocations('boxname', box);
      this.setState({ filterApplied: true });
    } else {
      this.setState({ filterApplied: false });
      this.props.getEpikBoxesDataByName(this.token, {}, tab);
      await this.getMapLocations('all', {});
      this.props.setCompanyFilter({});
    }
  };

  onBoxClick = box => {
    if (typeof box._id !== 'string') {
      return this.setState({ selectedBox: null });
    }

    this.props.addStep({ label: box.boxName, redirect: '' });
    this.props.setBoxDetailsData(this.token, box);
    this.setState({ selectedBox: box });
  };

  onNewEpikbox = async val => {
    const companyName = val.companyName;
    delete val.companyName

    if (this.state.onSerialNumberSelect) {
      // serialNumber
      const res = await this.props.updateBox(this.token, val);
      if (res) {
        const body = {
          actionType: 'system',
          description: `New Device ${val?.serialNumber} assigned to ${companyName} `,
        };
        await this.props.addSystemLogs(this.token, body);
      }
      this.props.cancelCreateEpikBox();
    } else {

      let res = await this.props.addEpikBox(this.token, val);
      if (res) {
        const body = {
          actionType: 'system',
          description: ` New Device assigned to ${companyName} `,
        };
        await this.props.addSystemLogs(this.token, body);
        this.props.sendBulkActionsToApi();
      }
    }
    this.updateBoxesData();
    this.setState({ disableCompany: false });
    const pagination = { page: 1, limit: 10 };
    await this.props.getEpikBoxesDetail(this.token, '', pagination);
  };

  onSerialNumberSelect = e => {
    this.setState({ onSerialNumberSelect: e });
  };

  onDeleteBoxConfirm = async () => {
    const res = await this.props.deleteEpikBox(this.token, this.props.boxToDelete);
    if (res) {
      const body = {
        actionType: 'system',
        description: `device ${this.props.boxToDelete?._id} with full detail ${JSON.stringify(this.props.boxToDelete)} deleted `,
      };
      await this.props.addSystemLogs(this.token, body);
    }
    this.updateBoxesData();
  };

  onBoxMonitorToggle = async (value, id, assignedTo) => {
    const mode = {
      ...{
        _id: id,
        assignedTo,
      },
      monitor: !value,
    };
    await this.props.setBoxMonitorToggleState(this.token, mode);
    // await this.props.updateBox(this.token, mode);
    await this.updateBoxesData();
  };

  updateEpikFields = async formData => {
    if (!formData) {
      this.props.cancelUpdateEpikBox();
    } else {
      this.setState({ isOpen: false });

      const res = await this.props.updateBox(this.token, formData);
      if (res) {
        const body = {
          actionType: 'system',
          description: `Device ${formData?.serialNumber} assigned to  ${formData?.assignedTo} `,
        };
        await this.props.addSystemLogs(this.token, body);
      }
      await this.updateBoxesData();
    }
  };

  onEnabledChange = value => {
    this.props.filterByStatus(!value);
  };

  handleChangePagination = async page => {
    const { dbSort } = this.state;
    const { user, getEpikBoxesDetail } = this.props;
    const { limit } = this.props.boxesList;
    const pagination = { page, limit, sort: dbSort };
    if (
      user.company.companyType !== 'manufacturer' &&
      (user.role === 'superAdmin' ||
        user.role === 'supportEngineer' ||
        user.role === 'companyGroupAdmin' ||
        user.role === 'companyGroupManager' ||
        user.role === 'supportEngineer')
    ) {
      await getEpikBoxesDetail(this.token, undefined, pagination);
    } else {
      await getEpikBoxesDetail(this.token, user.company._id, pagination);
    }
  };

  serialSearchFilter = async e => {
    var value = e?.trim();
    this.setState({ serialNumberFilter: value });
    const data = {};
    if (e?.length !== 0) {
      if (e?.length >= 4) {
        data['name'] = 'serialNumberFilter';
        data['value'] = value;
        data['suggestion'] = {};
        data['suggestion']['name'] = 'serialNumberFilter';
        data['suggestion']['value'] = value;

        this.props.clearBoxPagination();
        await this.props.getEpikBoxesBySerialNumber(this.token, value, tab);
        await this.getMapLocations('serialNumber', value);
        await this.props.setCompanyFilter(data);
        this.setState({ filterApplied: true });
      }
    } else {
      this.setState({ serialNumberFilter: '', filterApplied: false });
      await this.props.getEpikBoxesBySerialNumber(this.token, {}, tab);
      await this.getMapLocations('all', {});
      await this.props.setCompanyFilter({});
    }
  };

  onFavorites = async () => {
    if (this.state.onFavorites) {
      await this.props.clearBoxPagination();
      await this.props.setCompanyFilter({});
      this.setState({ onFavorites: false, filterApplied: false, selectedFilter: 'Company' });
    } else {
      this.setState({ selectedFilter: 'Favorites' })
      await this.props.clearBoxPagination();
      await this.props.getEpikBoxesByFavorites(this.token, tab);
      await this.props.setCompanyFilter({ name: 'Favorites', value: 'Favorites', suggestion: { name: 'Favorites', value: 'Favorites' } });
      this.setState({ onFavorites: true, filterApplied: true });
    }

  };

  macAddressSearchFilter = async e => {
    var value = e?.trim();
    this.setState({ macAddressFilter: value });
    const data = {};
    if (e?.length !== 0) {
      data['name'] = 'macAddressFilter';
      data['value'] = value;
      data['suggestion'] = {};
      data['suggestion']['name'] = 'macAddressFilter';
      data['suggestion']['value'] = value;
      this.props.clearBoxPagination();
      await this.props.getEpikBoxesByMacAddress(this.token, value, tab);
      await this.getMapLocations('macAddress', value);
      await this.props.setCompanyFilter(data);
      this.setState({ filterApplied: true });
    } else {
      this.setState({ macAddressFilter: '', filterApplied: false });
      await this.props.getEpikBoxesByMacAddress(this.token, {}, tab);
      await this.getMapLocations('all', {});
      await this.props.setCompanyFilter({});
    }
  };
  statusFilter = async e => {
    const data = {};
    if (e?.length !== 0) {
      data['name'] = 'status';
      data['value'] = e;
      data['suggestion'] = {};
      data['suggestion']['name'] = 'status';
      data['suggestion']['value'] = e;
      this.setState({ statusFilterValue: e });
      this.props.clearBoxPagination();
      await this.props.getEpikBoxesByStatus(this.token, e, tab, this.props.boxPagination);
      if (e !== 'All') {
        await this.getMapLocations('status', e?.toLowerCase());
      } else {
        await this.getMapLocations('all', e?.toLowerCase());
      }
      await this.props.setCompanyFilter(data);
      this.setState({ filterApplied: true });
    } else {
      this.setState({ filterApplied: false });
      await this.props.getEpikBoxesByStatus(this.token, {}, tab, this.props.boxPagination);
      await this.getMapLocations('all', {});
      await this.props.setCompanyFilter({});
    }
  };

  trackingNumberFilter = async e => {
    const data = {};
    if (e?.length !== 0) {
      data['name'] = 'trackingNumber';
      data['value'] = e;
      data['suggestion'] = {};
      data['suggestion']['name'] = 'trackingNumber';
      data['suggestion']['value'] = e;
      this.setState({ trackingNumber: e });
      this.props.clearBoxPagination();
      await this.props.getEpikBoxesByTrackingNumber(this.token, e, tab, this.props.boxPagination);
      if (e !== 'All') {
        await this.getMapLocations('trackingNumber', e?.toLowerCase());
      } else {
        await this.getMapLocations('all', e?.toLowerCase());
      }
      await this.props.setCompanyFilter(data);
      this.setState({ filterApplied: true });
    } else {
      this.setState({ filterApplied: false });
      await this.props.getEpikBoxesByTrackingNumber(this.token, {}, tab, this.props.boxPagination);
      await this.getMapLocations('all', {});
      await this.props.setCompanyFilter({});
    }
  };

  assignedSearchFilter = async e => {
    e = e?.trim();
    this.setState({ assignedNumberFilter: e });
    const data = {};
    if (e?.length !== 0) {
      data['name'] = 'assignedNumberFilter';
      data['value'] = e;
      data['suggestion'] = {};
      data['suggestion']['name'] = 'assignedNumberFilter';
      data['suggestion']['value'] = e;

      await this.props.getEpikBoxesByAssignedNumber(this.token, e, tab);
      await this.getMapLocations('assignedNumber', e);
      await this.props.setCompanyFilter(data);
      this.setState({ filterApplied: true });
    } else {
      this.setState({ assignedNumberFilter: '', filterApplied: false });
      await this.props.getEpikBoxesByAssignedNumber(this.token, {}, tab);
      await this.getMapLocations('all', {});
      await this.props.setCompanyFilter({});
    }
  };

  vpnAddressFilter = async e => {
    e = e?.trim();
    this.setState({ vpnAddressFilter: e });
    const data = {};
    if (e?.length !== 0) {
      data['name'] = 'vpnAddressFilter';
      data['value'] = e;
      data['suggestion'] = {};
      data['suggestion']['name'] = 'vpnAddressFilter';
      data['suggestion']['value'] = e;

      await this.props.getEpikBoxesByVPNAddress(this.token, e);
      await this.getMapLocations('vpnAddress', e);
      await this.props.setCompanyFilter(data);
      this.setState({ filterApplied: true });
    } else {
      this.setState({ vpnAddressFilter: '', filterApplied: false });
      await this.props.getEpikBoxesByVPNAddress(this.token, {});
      await this.getMapLocations('all', {});
      await this.props.setCompanyFilter({});
    }
  };

  obiSearchFilter = async (e = '') => {
    e = e?.trim();
    const data = {};
    if (e?.length >= 9) {
      data['name'] = 'obiNumberFilter';
      data['value'] = e;
      data['suggestion'] = {};
      data['suggestion']['name'] = 'obiNumberFilter';
      data['suggestion']['value'] = e;
      await this.props.getEpikBoxesDataByObi(this.token, e, tab);
      await this.getMapLocations('obiNumber', e);
      await this.props.setCompanyFilter(data);
      this.setState({ filterApplied: true });
    } else if (e?.length === 0) {
      this.setState({ obiNumberFilter: '', filterApplied: false });
      await this.props.getEpikBoxesDataByObi(this.token, {}, tab);
      await this.getMapLocations('all', {});
      await this.props.setCompanyFilter({});
    }
  };

  imeiNumberFilter = async (e = '') => {
    const { getEpikBoxesDataByIMEI, setCompanyFilter } = this.props;
    const val = e?.trim();
    const data = {};
    if (val?.length !== 0) {
      data['name'] = 'imeiNumberFilter';
      data['value'] = val;
      data['suggestion'] = {};
      data['suggestion']['name'] = 'imeiNumberFilter';
      data['suggestion']['value'] = val;
      await getEpikBoxesDataByIMEI(this.token, val, tab);
      await this.getMapLocations('imeis', val);
      await setCompanyFilter(data);
      this.setState({ filterApplied: true });
    } else if (val?.length === 0) {
      this.setState({ imeiNumber: '', filterApplied: false });
      await getEpikBoxesDataByIMEI(this.token, {}, tab);
      await this.getMapLocations('all', {});
      await setCompanyFilter({});
    }
  };

  simNumberFilter = async (e = '') => {
    const { getEpikBoxesDataBySIM, setCompanyFilter } = this.props;
    const val = e?.trim();
    const data = {};
    if (val?.length !== 0) {
      data['name'] = 'simNumberFilter';
      data['value'] = val;
      data['suggestion'] = {};
      data['suggestion']['name'] = 'simNumberFilter';
      data['suggestion']['value'] = val;
      await getEpikBoxesDataBySIM(this.token, val, tab);
      await this.getMapLocations('sims', val);
      await setCompanyFilter(data);
      this.setState({ filterApplied: true });
    } else if (val?.length === 0) {
      this.setState({ simNumber: '', filterApplied: false });
      await getEpikBoxesDataBySIM(this.token, {}, tab);
      await this.getMapLocations('all', {});
      await setCompanyFilter({});
    }
  };

  createdDateFilter = async (e = '') => {
    const { getEpikBoxesDataByCreated, setCompanyFilter } = this.props;
    const val = e?.trim();
    const data = {};
    if (val?.length !== 0) {
      data['name'] = 'createdDateFilter';
      data['value'] = val;
      data['suggestion'] = {};
      data['suggestion']['name'] = 'createdDateFilter';
      data['suggestion']['value'] = val;
      await getEpikBoxesDataByCreated(this.token, val, tab);
      await this.getMapLocations('created', val);
      await setCompanyFilter(data);
      this.setState({ filterApplied: true });
    } else if (val?.length === 0) {
      alert("error")
      this.setState({ created: '', filterApplied: false });
      await getEpikBoxesDataByCreated(this.token, {}, tab);
      await this.getMapLocations('all', {});
      await setCompanyFilter({});
    }
  };


  onDateSelect = async (event, picker) => {
    const startDate = picker.startDate.format("YYYY-MM-DD");
    const endDate = picker.endDate.format("YYYY-MM-DD");
    this.setState({ created: startDate + ' ' + endDate })
  }

  onKeyPress = async e => {
    const {
      serialNumberFilter,
      obiNumberFilter,
      boxFilter,
      macAddressFilter,
      trackingNumber,
      vpnaddressFilter,
      imeiNumber,
      simNumber,
      created
    } = this.state;
    const { getEpikBoxesDataByObi, setCompanyFilter, getEpikBoxesBySerialNumber } = this.props;
    const data = {};
    if (e?.key === 'Enter') {
      if (obiNumberFilter.length !== 0) {
        data['name'] = 'obiNumberFilter';
        data['value'] = obiNumberFilter;
        data['suggestion'] = {};
        data['suggestion']['name'] = 'obiNumberFilter';
        data['suggestion']['value'] = obiNumberFilter;
        getEpikBoxesDataByObi(this.token, obiNumberFilter, tab);
        await this.getMapLocations('obiNumber', obiNumberFilter);
        setCompanyFilter(data);
      } else if (serialNumberFilter) {
        this.serialSearchFilter(serialNumberFilter);
      } else if (boxFilter) {
        this.onBoxFilter(boxFilter);
      } else if (macAddressFilter) {
        this.macAddressSearchFilter(macAddressFilter);
      } else if (trackingNumber) {
        this.trackingNumberFilter(trackingNumber);
      } else if (vpnaddressFilter) {
        this.vpnAddressFilter(vpnaddressFilter);
      } else if (imeiNumber) {
        this.imeiNumberFilter(imeiNumber);
      } else if (created) {
        this.createdDateFilter(created);
      } else if (simNumber) {
        this.simNumberFilter(simNumber);
      } else {
        this.setState({
          obiNumberFilter: '',
          serialNumberFilter: '',
          boxFilter: '',
          macAddressFilter: '',
          filterApplied: false,
        });
        await getEpikBoxesBySerialNumber(this.token, {}, tab);
        await this.getMapLocations('all', {});
        await setCompanyFilter({});
      }
    }
  };
  onKeyAssignPress = async e => {
    if (e?.key === 'Enter') {
      const { assignedNumberFilter } = this.state;
      const data = {};
      const { activeBoxTab } = this.props;
      const tab = activeBoxTab === 'online' ? true : false;
      if (assignedNumberFilter.length !== 0) {
        data['name'] = 'assignedNumberFilter';
        data['value'] = assignedNumberFilter;
        data['suggestion'] = {};
        data['suggestion']['name'] = 'assignedNumberFilter';
        data['suggestion']['value'] = assignedNumberFilter;

        await this.props.getEpikBoxesByAssignedNumber(this.token, assignedNumberFilter, tab);
        await this.getMapLocations('assignedNumber', assignedNumberFilter);
        await this.props.setCompanyFilter(data);
        this.setState({ filterApplied: true });
      } else {
        toast.error('Please enter some number.');
      }
    }
  };

  toggleDropDown = () => {
    this.setState({ dropdownOpen: !this.state.dropdownOpen });
  };

  onOptionSelect = e => {
    this.setState({
      selectedFilter: e,
      serialNumberFilter: '',
      assignedNumberFilter: '',
      obiNumberFilter: '',
      boxFilter: '',
      macAddressFilter: '',
      trackingNumber: '',
      vpnaddressFilter: '',
      imeiNumber: '',
    });
  };

  updateBoxMonitor = e => {
    this.updateEpikFields(e);
  };

  handleSetLimit = async limit => {
    const { user, getEpikBoxesDetail } = this.props;
    const pagination = { page: 1, limit: limit };
    if (
      user.company.companyType !== 'manufacturer' &&
      (user.role === 'superAdmin' ||
        user.role === 'supportEngineer' ||
        user.role === 'companyGroupAdmin' ||
        user.role === 'companyGroupManager')
    ) {
      await getEpikBoxesDetail(this.token, undefined, pagination);
    } else {
      await getEpikBoxesDetail(this.token, user.company._id, pagination);
    }
  };

  onRecoverBox = async e => {
    var res = await this.props.onRecover(this.token, e?._id);
    if (res) {
      await this.props.getEpikBoxesData(this.token, this.companyID, 'none');
      this.props.getBoxCount(this.token, this.companyID);
    }
  };

  showNotes = e => {
    this.setState({ showNotes: e });
  };

  addNotes = async e => {
    const { boxDetails, addNote, getNotes } = this.props;
    var obj = new FormData();
    obj.append('file', e?.file || '');
    obj.append('note', e?.note || '');
    obj.append('type', e?.type || 'none');
    obj.append('isBoxTab', true);
    obj.append('boxId', boxDetails._id);
    var res = await addNote(this.token, this.state.selectedNoteBox, obj);
    if (res) {
      getNotes(this.token, this.state.selectedNoteBox);
    }
  };

  selectedBox = e => {
    this.setState({ selectedNoteBox: e });
    this.props.getNotes(this.token, e);
  };

  handleNotesPagination = async page => {
    this.notesPagination = { page, limit: 10 };
    this.props.getNotes(this.token, this.state.selectedNoteBox, this.notesPagination);
  };

  onEditNote = async (e, note_id) => {
    const { boxDetails, editNote, getNotes } = this.props;
    var obj = new FormData();
    obj.append('attachment', JSON.stringify(e?.attachment) || '');
    obj.append('createdAt', e?.createdAt || '');
    obj.append('epikBox', e?.epikBox || '');
    obj.append('file', e?.file || '');
    obj.append('note', e?.note || '');
    obj.append('updatedAt', e?.updatedAt || '');
    obj.append('user', JSON.stringify(e?.user) || '');
    obj.append('_id', e?._id || '');
    obj.append('isBoxTab', true);
    obj.append('boxId', boxDetails._id);

    var res = await editNote(this.token, this.state.selectedNoteBox, obj, note_id);
    if (res) {
      getNotes(this.token, this.state.selectedNoteBox, this.notesPagination);
    }
  };

  downloadAttachment = (id, name) => {
    this.props.downloadAttachment(this.token, id, name);
  };

  onDeleteNote = note_id => {
    var res = this.props.deleteNote(this.token, this.state.selectedNoteBox, note_id);
    if (res) {
      this.props.getNotes(this.token, this.state.selectedNoteBox, this.notesPagination);
    }
  };
  onDeleteNoteRecording = async note_id => {
    const { deleteNoteRecording, getNotes } = this.props;
    const { selectedNoteBox } = this.state;
    await deleteNoteRecording(this.token, note_id);
    await getNotes(this.token, selectedNoteBox, this.notesPagination);
  };

  handleImportBox = () => {
    this.setState({ importModal: !this.state.importModal });
  };

  confimImportBox = async number => {
    var res = await this.props.importEpikBox(this.token, number);
    if (res) {
      this.setState({ disableCompany: true });
    } else {
      this.setState({ disableCompany: false });
    }
    this.setState({ importModal: false });
  };

  handleViewChange = e => {
    this.setState({ viewMode: e });
  };

  handleBoxPagination = async page => {
    const { dbSort } = this.state;
    const { boxPagination, setBoxPagination } = this.props;
    const { limit } = boxPagination;
    const options = { page, limit, sort: dbSort };
    await setBoxPagination(options);
    this.updateBoxesData();
  };

  handleBoxLimit = async limit => {
    const { setBoxPagination, clearBoxPagination } = this.props;
    const options = { page: 1, limit };
    await clearBoxPagination();
    await setBoxPagination(options);
    this.updateBoxesData();
  };

  onAdvanceSearchPress = () => {
    this.setState({ searchModalStatus: true, selectedFilter: 'advanceFilter' });
  };

  onRecentSearches = () => {
    this.setState({ searchModalStatus: true, recentStatus: true });
  };

  advanceArrayFunction = advanceArray => {
    this.setState({ advanceArray });
  };

  onAdvanceConfirm = async () => {
    const { advanceArray } = this.state;
    // eslint-disable-next-line no-shadow
    const {
      boxPagination,
      getEpikBoxesByAdSearch,
      setCompanyFilter,
      advanceLocalArray,
    } = this.props;
    advanceLocalArray(advanceArray);

    const data = {};

    data['name'] = _.camelCase(advanceArray[0]?.type);
    data['value'] = advanceArray[0]?.value;
    data['suggestion'] = {};
    data['suggestion']['name'] = _.camelCase(advanceArray[0]?.type);
    data['suggestion']['value'] = advanceArray[0]?.value;

    const emptyValue = Object.values(advanceArray).every(
      e => e.value.length || Object.values(e.value).every(x => x.length),
    );
    if (!emptyValue) {
      return toast.error('Please fill all the fields');
    }

    // PARAMS STRING
    const params = advanceArray
      .map(e => {
        const camelCase = _.camelCase(e.type);

        if (e.type === 'Date Range') {
          const { startDate, endDate } = e.value;
          return `from=${startDate}&to=${endDate}`;
        }
        if (e.type === 'EngineeringLock') {
          return `${camelCase}=${e.value.toLowerCase()}`;
        }

        return `${camelCase}=${e.value}`;
      })
      .join('&');

    // eslint-disable-next-line no-shadow
    await getEpikBoxesByAdSearch(this.token, params, boxPagination);
    await setCompanyFilter(data);
    this.setState({ searchModalStatus: false, filterApplied: true, advanceParams: params });
  };

  onRemoveStatus = async () => {
    console.log('remove status');
  }


  render() {
    const {
      sort,
      viewMode,
      enableBoxEdit,
      searchModalStatus,
      selectedBox,
      recentStatus,
      advanceArray,
      favoritesModalStatus,
      onFavorites,
    } = this.state;
    const {
      boxesList,
      companyFilter,
      user,
      companies,
      locations,
      companyGroupDropdownList,
      selectedBoxes,
    } = this.props;
    if (selectedBox && selectedBox._id) {
      const companyId = companyFilter.suggestion
        ? companyFilter.suggestion._id
        : selectedBox.assignedTo._id;
      return (
        <Redirect
          push
          to={`/boxes/${selectedBox._id}?company=${companyId || selectedBox.assignedTo}`}
        />
      );
    }

    const renderList = sort.name?.length
      ? boxesList?.docs?.length && boxesList?.docs?.length && this.sortColumnByKey(boxesList.docs)
      : boxesList.docs;

    const allowedUsersFilter = [
      'superAdmin',
      'admin',
      'supportEngineer',
      'companyGroupAdmin',
      'companyGroupManager',
    ];



    return (
      <div>
        <div className="filter-section">
          <Row>
            {/* <Col md={4} sm={12}>
              <Breadcrumbs />
            </Col> */}
            <Col md={12} sm={12}>
              <div
                className="row box-filters justify-content-end">
                <Col xs="auto" md={2}>
                  <Row>
                    {user.role === 'superAdmin' && !!selectedBoxes.length && (
                      <Button
                        color="primary"
                        onClick={() => this.setState({ BulkBoxAssignmentModal: true })}
                        className="mr-2"
                      >
                        Bulk Assignment
                      </Button>
                    )}
                    {(user.role === 'superAdmin' ||
                      user.role === 'supportEngineer' ||
                      user.role === 'companyGroupAdmin') && (
                        <>
                          {' '}
                          <Button color="primary" onClick={this.onAssignBoxPress}>
                            Assign Edge Device
                          </Button>
                        </>
                      )}
                  </Row>
                </Col>
                {this.props.user.role === 'superAdmin' ||
                  this.props.user.role === 'admin' ||
                  this.props.user.role === 'enterpriseAdmin' ||
                  this.props.user.role === 'supportEngineer' ||
                  this.props.user.role === 'companyGroupAdmin' ||
                  this.props.user.role === 'companyGroupManager' ? (
                  <Col md={4} className="select-status">
                    <InputGroup style={{ marginBottom: '1em' }}>
                      <InputGroupAddon addonType="prepend" className="filter-icon-div">
                        <img src={filterIcon} className="filter-icon" alt="filter" />
                      </InputGroupAddon>

                      <Input
                        type="select"
                        className="filter-append-dropdown"
                        onChange={e => this.onOptionSelect(e?.currentTarget.value)}
                      >
                        `
                        {user.company.companyType !== 'manufacturer' && user.role !== 'admin' && (
                          <option key="Company" value="Company">
                            Company
                          </option>
                        )}
                        <option key="Edge Device Name" value="Edge Device Name">
                          Edge Device Name
                        </option>
                        <option key="Status" value="Status">
                          Status
                        </option>
                        <option key="Assigned Number" value="Assigned Number">
                          Assigned Number
                        </option>
                        <option key="EPI Number" value="EPI Number">
                          EPI Number
                        </option>
                        <option key="Serial Number" value="Serial Number">
                          Serial Number
                        </option>
                        <option key="Mac Address" value="Mac Address">
                          MAC Address
                        </option>
                        {user.role !== 'admin' && (
                          <option key="By Group" value="By Group">
                            By Group
                          </option>
                        )}
                        {user.role === 'superAdmin' && (
                          <option key="Shipping Tracking Number" value="Shipping Tracking Number">
                            Shipping Tracking Number
                          </option>
                        )}
                        {user.role === 'superAdmin' && (
                          <option key="VPN Address" value="VPN Address">
                            VPN Address
                          </option>
                        )}
                        <option key="IMEI" value="IMEI">
                          IMEI
                        </option>
                        <option key="SIM" value="SIM">
                          SIM
                        </option>
                        <option key="created" value="created">
                          Created On
                        </option>
                      </Input>
                    </InputGroup>
                    <>
                      {this.state.selectedFilter === 'Company' ? (
                        this.props.companies.docs && (
                          <>
                            <CompanyAutocomplete
                              // searchTerm={this.props.companyFilter?.value}
                              className="testing-filter"
                              placeholder="Filter"
                              companies={this.props.companies.docs}
                              onChange={e => this.onCompanyFilter(e, 'searchBox')}
                            />
                            {this.state.locationStatus && viewMode !== 'map' && (
                              <Col md={{ size: 4 }}>
                                <LocationDetails
                                  boxesLocation
                                  selectLocation={this.locationFilter}
                                  locations={this.props.locations}
                                />
                              </Col>
                            )}
                          </>
                        )
                      ) : this.state.selectedFilter === 'EPI Number' ? (
                        <InputGroup>
                          <Input
                            type="text"
                            placeholder={`Filter`}
                            onKeyDown={e => this.onKeyPress(e)}
                            value={this.state.obiNumberFilter}
                            onChange={e => this.setState({ obiNumberFilter: e?.target.value })}
                            style={{ marginBottom: '1em' }}
                          />
                          <Button
                            color="primary"
                            className="box-search-btn"
                            onClick={() => this.obiSearchFilter(this.state.obiNumberFilter)}
                          >
                            Search
                          </Button>
                        </InputGroup>
                      ) : this.state.selectedFilter === 'Serial Number' ? (
                        <InputGroup>
                          <Input
                            type="text"
                            placeholder={`Filter`}
                            onKeyDown={e => this.onKeyPress(e)}
                            value={this.state.serialNumberFilter}
                            onChange={e => this.setState({ serialNumberFilter: e?.target.value })}
                            style={{ marginBottom: '1em' }}
                          />
                          <Button
                            color="primary"
                            className="box-search-btn"
                            onClick={() => this.serialSearchFilter(this.state.serialNumberFilter)}
                          >
                            Search
                          </Button>
                        </InputGroup>
                      ) : this.state.selectedFilter === 'Mac Address' ? (
                        <InputGroup>
                          <Input
                            type="text"
                            placeholder={`Filter`}
                            onKeyDown={e => this.onKeyPress(e)}
                            value={this.state.macAddressFilter}
                            onChange={e => this.setState({ macAddressFilter: e?.target.value })}
                            style={{ marginBottom: '1em' }}
                          />
                          <Button
                            color="primary"
                            className="box-search-btn"
                            onClick={() => this.macAddressSearchFilter(this.state.macAddressFilter)}
                          >
                            Search
                          </Button>
                        </InputGroup>
                      ) : this.state.selectedFilter === 'Assigned Number' ? (
                        <InputGroup>
                          <Input
                            type="text"
                            placeholder={`Filter`}
                            onKeyDown={e => this.onKeyAssignPress(e)}
                            value={this.state.assignedNumberFilter}
                            onChange={e => this.setState({ assignedNumberFilter: e?.target.value })}
                            style={{ marginBottom: '1em' }}
                          />
                          <Button
                            color="primary"
                            className="box-search-btn"
                            onClick={() =>
                              this.assignedSearchFilter(this.state.assignedNumberFilter)
                            }
                          >
                            Search
                          </Button>
                        </InputGroup>
                      ) : this.state.selectedFilter === 'VPN Address' ? (
                        <InputGroup>
                          <Input
                            type="text"
                            placeholder={`Filter`}
                            onKeyDown={e => this.onKeyPress(e)}
                            value={this.state.vpnaddressFilter}
                            onChange={e => this.setState({ vpnaddressFilter: e?.target.value })}
                            style={{ marginBottom: '1em' }}
                          />
                          <Button
                            color="primary"
                            className="box-search-btn"
                            onClick={() => this.vpnAddressFilter(this.state.vpnaddressFilter)}
                          >
                            Search
                          </Button>
                        </InputGroup>
                      ) : this.state.selectedFilter === 'Status' ? (
                        <Input
                          type="select"
                          style={{ marginBottom: '1em' }}
                          onChange={e => {
                            let val = e.target.value;
                            if (e.target.value === 'Registered')
                              val = 'Online';
                            else if (e.target.value === 'UnRegistered')
                              val = 'Offline';
                            this.statusFilter(val);
                          }}
                        >
                          {filterStatusOptions.map(el => (
                            <option key={el} value={el}>
                              {el}
                            </option>
                          ))}
                        </Input>
                      ) : this.state.selectedFilter === 'By Group' ? (
                        <CompanyAutocomplete
                          className="testing-filter"
                          placeholder="Filter"
                          companies={this.props.companyGroupDropdownList.docs}
                          onChange={e => this.handleFilterByGroupID(e)}
                        />
                      ) : this.state.selectedFilter === 'Shipping Tracking Number' ? (
                        <InputGroup>
                          <Input
                            type="text"
                            placeholder="Filter"
                            onKeyDown={e => this.onKeyPress(e)}
                            value={this.state.trackingNumber}
                            onChange={e => this.setState({ trackingNumber: e?.target.value })}
                            style={{ marginBottom: '1em' }}
                          />
                          <Button
                            color="primary"
                            className="box-search-btn"
                            onClick={() => this.trackingNumberFilter(this.state.trackingNumber)}
                          >
                            Search
                          </Button>
                        </InputGroup>
                      ) : this.state.selectedFilter === 'IMEI' ? (
                        <InputGroup>
                          <Input
                            type="text"
                            placeholder="Filter"
                            onKeyDown={e => this.onKeyPress(e)}
                            value={this.state.imeiNumber}
                            onChange={e => this.setState({ imeiNumber: e?.target.value })}
                            style={{ marginBottom: '1em' }}
                          />
                          <Button
                            color="primary"
                            className="box-search-btn"
                            onClick={() => this.imeiNumberFilter(this.state.imeiNumber)}
                          >
                            Search
                          </Button>
                        </InputGroup>
                      ) : this.state.selectedFilter === 'SIM' ? (
                        <InputGroup>
                          <Input
                            type="text"
                            placeholder="Filter"
                            onKeyDown={e => this.onKeyPress(e)}
                            value={this.state.simNumber}
                            onChange={e => this.setState({ simNumber: e?.target.value })}
                            style={{ marginBottom: '1em' }}
                          />
                          <Button
                            color="primary"
                            className="box-search-btn"
                            onClick={() => this.simNumberFilter(this.state.simNumber)}
                          >
                            Search
                          </Button>
                        </InputGroup>
                      ) : this.state.selectedFilter === 'created' ? (

                        <InputGroup>
                          {/* <Input
                            type="text"
                            placeholder="Filter"
                            onKeyDown={e => this.onKeyPress(e)}
                            value={this.state.created}
                            onChange={e => this.setState({ created: e?.target.value })}
                            style={{ marginBottom: '1em' }}
                          /> */}
                          <DateRangePicker containerStyles={{ width: '68%' }} onApply={this.onDateSelect}>
                            <input placeholder='Date Range' type="text" style={{ marginBottom: '1em', padding: '0px' }} className="form-control" value={`${this.state.created}`} readOnly={true} />
                          </DateRangePicker>
                          <Button
                            color="primary"
                            className="box-search-btn"
                            onClick={() => this.createdDateFilter(this.state.created)}
                          >
                            Search
                          </Button>
                        </InputGroup>
                      ) : (
                        <InputGroup>
                          <Input
                            type="text"
                            placeholder="Filter"
                            onKeyDown={e => this.onKeyPress(e)}
                            onChange={e => this.setState({ boxFilter: e?.target.value })}
                            value={this.state.boxFilter}
                            // onChange={e => this.onBoxFilter(e?.target)}
                            style={{ marginBottom: '1em' }}
                          />
                          <Button
                            color="primary"
                            className="box-search-btn"
                            onClick={() => this.onBoxFilter(this.state.boxFilter)}
                          >
                            Search
                          </Button>
                        </InputGroup>
                      )}
                    </>
                  </Col>
                ) : null}
              </div>
            </Col>
          </Row>
          <Row>
            <Col md={12} sm={12} className="d-flex flex-row-reverse bd-highlight">
              {(this.props.user.role === 'superAdmin' ||
                this.props.user.role === 'supportEngineer' ||
                this.props.user.role === 'companyGroupAdmin') && (
                  <Button className="ml-2" color="primary" onClick={this.onAdvanceSearchPress}>
                    Advanced Search
                  </Button>
                )}
              <Button color="primary" onClick={this.onRecentSearches}>
                Recent Searches
              </Button>
              {
                onFavorites ? (
                  <Favorite
                    fill='#4d9cd3'
                    id="remove-fav" className="favorite-size-lg" onClick={this.onFavorites} />
                ) : (
                  <Favorite
                    id="remove-fav" className="favorite-size-lg" onClick={this.onFavorites} />
                )
              }
              {/* <Button className="mr-2" color="primary" onClick={this.onFavorites}>
                Starred
                <FontAwesomeIcon icon="star" size="sm" className="ml-2" />
              </Button> */}
            </Col>
          </Row>
        </div>

        <div className="container-fluid epik-boxes" style={{ margin: 0 }}>
          {this.props.user.company.companyType !== 'manufacturer' &&
            (this.props.user.role === 'superAdmin' ||
              this.props.user.role === 'supportEngineer' ||
              this.props.user.role === 'companyGroupAdmin' ||
              this.props.user.role === 'companyGroupManager') &&
            !this.props.companyFilter?.value ? (
            <div className="viewContainer" style={{ marginTop: '20px' }}>
              <div className="box-table-header">
                <FontAwesomeIcon
                  icon="list-ul"
                  size="lg"
                  color={this.state.viewMode === 'list' ? '#3b5aa9' : '#000000'}
                  onClick={() => this.handleViewChange('list')}
                  className="map-list-icon"
                />
                <FontAwesomeIcon
                  icon="map-marked-alt"
                  size="lg"
                  color={this.state.viewMode === 'map' ? '#3b5aa9' : '#000000'}
                  onClick={() => this.handleViewChange('map')}
                  className="map-list-icon"
                />
              </div>
              {this.state.viewMode === 'list' ? (
                <>
                  <EpikBoxesTable
                    sortValue={sort}
                    onSort={this.handleSortBoxes}
                    onRecover={this.onRecoverBox}
                    deleteMode={this.props.deleteMode}
                    selectedCompany={val => this.onCompanyFilter(val)}
                    boxesList={renderList}
                  />

                  <Row className="justify-content-md-center">
                    <SetLimitEntries onChange={this.handleSetLimit} />

                    {boxesList.totalPages > 1 && (
                      <Pagination
                        locale={ENG_LOCALE}
                        className="pagination-container"
                        onChange={this.handleChangePagination}
                        current={boxesList.page}
                        total={boxesList.totalDocs}
                        pageSize={boxesList.limit}
                        showLessItems
                        showTotal={(total, range) => `${range[0]} - ${range[1]} of ${total} items`}
                      />
                    )}
                  </Row>
                </>
              ) : (
                <div>
                  <EpikBoxesMap selectLocation={this.selectLocation} />
                </div>
              )}
            </div>
          ) : (
            <div className="viewContainer" style={{ marginTop: '20px' }}>
              <div className="box-table-header">
                <FontAwesomeIcon
                  icon="list-ul"
                  size="lg"
                  color={this.state.viewMode === 'list' ? '#3b5aa9' : '#000000'}
                  onClick={() => this.handleViewChange('list')}
                  className="map-list-icon"
                />
                <FontAwesomeIcon
                  icon="map-marked-alt"
                  size="lg"
                  color={this.state.viewMode === 'map' ? '#3b5aa9' : '#000000'}
                  onClick={() => this.handleViewChange('map')}
                  className="map-list-icon"
                />
              </div>
              {this.state.viewMode === 'list' ? (
                <>
                  <Row>
                    <Col md={12}>
                      {this.props.boxes.docs && (
                        <EpikBoxesList
                          selectedBox={this.selectedBox}
                          showNotesModal={this.showNotes}
                          filter={this.props.companyFilter && this.props.companyFilter.name}
                          onRecover={this.onRecoverBox}
                          deleteMode={this.props.deleteMode}
                          user={this.props.user}
                          boxList={
                            sort.name?.length
                              ? this.props.boxes?.docs?.length &&
                              this.sortColumnByKey(this.props.boxes.docs)
                              : this.props.boxes.docs
                          }
                          sortValue={sort}
                          onSort={this.handleSortBoxes}
                          online={true}
                          updateBoxMonitor={this.updateBoxMonitor}
                          onBoxClick={this.onBoxClick}
                          onBoxDelete={this.props.showDeleteEpikBox}
                          onUpdateBox={this.props.showUpdateEpikBox}
                          onFavorites={onFavorites}
                          onRemoveStatus={this.onRemoveStatus}
                        />
                      )}
                    </Col>
                  </Row>
                  {this.props.boxes.totalPages > 1 && (
                    <Row className="justify-content-md-center">
                      <SetLimitEntries onChange={this.handleBoxLimit} />
                      <Pagination
                        locale={ENG_LOCALE}
                        className="pagination-container"
                        onChange={this.handleBoxPagination}
                        current={this.props.boxes.page}
                        total={this.props.boxes.totalDocs}
                        pageSize={this.props.boxes.limit}
                        showLessItems
                        showTotal={(total, range) => `${range[0]} - ${range[1]} of ${total} items`}
                      />
                    </Row>
                  )}
                </>
              ) : (
                <div>
                  <EpikBoxesMap selectLocation={this.selectLocation} />
                </div>
              )}
            </div>
          )}
          <BulkBoxAssignmentModal
            isOpen={this.state.BulkBoxAssignmentModal}
            onCancel={() => this.setState({ BulkBoxAssignmentModal: false })}
            onConfirm={value => this.bulkAssign(value)}
          />
          <ImportEpikBoxModal
            modal={this.state.importModal}
            toggle={this.handleImportBox}
            onConfirm={this.confimImportBox}
          />
          <NewEpikboxModal
            unassignedBoxes={this.props.unassignedBoxes}
            locations={this.props.locations}
            getLocationByCompany={e => this.props.getLocationByCompany(this.token, e)}
            disableCompany={this.state.disableCompany}
            onCancel={() => {
              this.setState({ disableCompany: false });
              this.props.cancelCreateEpikBox();
            }}
            onConfirm={this.onNewEpikbox}
            isOpen={this.props.createBoxOpen}
            companies={this.props.companies}
            importModal={this.state.importModal}
            importObj={this.props.importObj}
            onSerialNumberSelect={this.onSerialNumberSelect}
          />
          <DeleteBoxModal
            onConfirm={this.onDeleteBoxConfirm}
            onCancel={this.props.cancelDeleteEpikBox}
            isOpen={this.props.deleteBoxOpen}
          />
          <AddNotesList
            onEditNote={this.onEditNote}
            onDownload={this.downloadAttachment}
            onDeleteNote={this.onDeleteNote}
            onDeleteNoteRecording={this.onDeleteNoteRecording}
            user={this.props.user}
            handleChangePagination={this.handleNotesPagination}
            isOpen={this.state.showNotes}
            onConfirm={this.addNotes}
            onCancel={() => {
              this.setState({ showNotes: false });
            }}
            boxNotes={this.props.boxNotes}
            boxDetails={this.props.boxDetails}
          />
          {this.props.boxToUpdate ? (
            <UpdateEpikBoxModal
              isOpen={this.props.updateBoxOpen}
              enableBoxEdit={enableBoxEdit}
              onConfirm={this.updateEpikFields}
              onCancel={this.props.cancelUpdateEpikBox}
              box={this.props.boxToUpdate}
              user={this.props.user}
            />
          ) : null}
        </div>

        <CustomModal
          header={recentStatus ? 'Recent Searches' : 'Advanced Search'}
          isOpen={searchModalStatus}
          onCancel={() => this.setState({ searchModalStatus: false, recentStatus: false })}
          onConfirm={recentStatus ? null : () => this.onAdvanceConfirm()}
          submitDisplay={recentStatus}
          confirmDisabled={!recentStatus && !advanceArray[0]?.value}
        >
          {recentStatus ? (
            <RecentSearches onRecentBox={this.onBoxClick} />
          ) : (
            <AdvanceSearchBody
              user={user}
              companies={companies}
              locations={locations}
              companyGroupDropdownList={companyGroupDropdownList}
              advanceList={e => this.advanceArrayFunction(e)}
            />
          )}
        </CustomModal>
        <CustomModal
          header="Favorite Boxes"
          isOpen={favoritesModalStatus}
          onCancel={() => this.setState({ favoritesModalStatus: false })}
          submitDisplay={false}
        >
          <FavoriteBoxes onRecentBox={this.onBoxClick} />
        </CustomModal>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    companyGroupDropdownList: state.AppState.companyGroupListDropdown,
    selectedBoxes: state.UIState.epikBoxes.selectedBoxes,
    user: state.AppState.user,
    companyGroupList: state.AppState.companyGroupList,
    boxes: state.AppState.boxes,
    companies: state.AppState.companies,
    allBoxes: state.AppState.allBoxes,
    companyFilter: state.UIState.epikBoxes.companyFilter,
    boxPagination: state.UIState.epikBoxes.pagination,
    createBoxOpen: state.UIState.epikBoxes.createBoxOpen,
    deleteBoxOpen: state.UIState.epikBoxes.deleteBoxOpen,
    boxToDelete: state.UIState.epikBoxes.boxToDelete,
    updateBoxOpen: state.UIState.epikBoxes.updateBoxOpen,
    boxToUpdate: state.UIState.epikBoxes.boxToUpdate,
    status: state.UIState.epikBoxes.filterByStatus,
    boxesList: state.AppState.boxesList,
    deleteMode: state.AppState.deleteMode,
    totalBoxes: state.AppState.totalBoxes,
    boxNotes: state.AppState.boxNotes,
    importObj: state.UIState.epikBoxDetails.importObj,
    locations: state.AppState.boxDetails.boxLocations,
    boxDetails: state.AppState.boxDetails.box,
    unassignedBoxes: state.AppState.unassignedBoxes,
  };
};

const mapDispatchToProps = dispatch => ({
  getBoxesByGroupID: (token, companyId, pagination) =>
    dispatch(getBoxesByGroupIDAction(token, companyId, pagination)),
  getCompanyGroupDropdownList: (token, pagination, paginateResult, onlyNames) =>
    dispatch(getAllCompanyGroups(token, pagination, paginateResult, onlyNames)),
  onRecover: (token, id) => dispatch(onRecover(token, id)),
  setBoxMonitorToggleState: (token, mode) => dispatch(setBoxMonitorToggleState(token, mode)),
  updateBox: (token, box) => dispatch(updateEpikBox(token, box)),
  getEpikBoxesData: (token, companyId, online, unmonitored, disablePagination, pagination, companyFilter) =>
    dispatch(
      getEpikBoxesData(token, companyId, online, unmonitored, disablePagination, pagination, companyFilter),
    ),
  getEpikBoxesDetail: (token, companyId, pagination) =>
    dispatch(getEpikBoxesDetail(token, companyId, pagination)),
  getEpikBoxLocations: token => dispatch(getEpikBoxLocations(token)),
  addEpikBox: (token, box) => dispatch(createEpikBox(token, box)),
  getCompanies: (token, pagination, disabledPagination, onlyName) =>
    dispatch(getCompanies(token, pagination, disabledPagination, undefined, undefined, onlyName)),
  clearEpikBoxes: () => dispatch(clearEpikBoxesData()),
  showCreateEpikBox: () => dispatch(showCreateEpikBox()),
  bulkAssignEpikBox: (token, payload) => dispatch(bulkAssignEpikBox(token, payload)),
  cancelCreateEpikBox: () => dispatch(cancelCreateEpikBox()),
  showDeleteEpikBox: box => dispatch(showDeleteEpikBox(box)),
  showUpdateEpikBox: box => dispatch(showUpdateEpikBox(box)),
  cancelUpdateEpikBox: box => dispatch(cancelUpdateEpikBox(box)),
  cancelDeleteEpikBox: () => dispatch(cancelDeleteEpikBox()),
  deleteEpikBox: (token, box) => dispatch(deleteEpikBox(token, box)),
  setCompanyFilter: filter => dispatch(epikBoxesCompanyFilter(filter)),
  advanceLocalArray: filter => dispatch(advanceLocalArray(filter)),
  setBoxDetailsData: (token, box) => dispatch(setBoxDetailsData(token, box)),
  filterByStatus: status => dispatch(filterByStatus(status)),
  getEpikBoxesDataByObi: (token, obiNumber, online, pagination) =>
    dispatch(getEpikBoxesDataByObi(token, obiNumber, online, pagination)),
  getEpikBoxesDataByIMEI: (token, obiNumber, online, pagination) =>
    dispatch(getEpikBoxesByIMEI(token, obiNumber, online, pagination)),
  getEpikBoxesDataBySIM: (token, obiNumber, online, pagination) =>
    dispatch(getEpikBoxesBySIM(token, obiNumber, online, pagination)),
  getEpikBoxesBySerialNumber: (token, serialNumber, online, pagination) =>
    dispatch(getEpikBoxesBySerialNumber(token, serialNumber, online, pagination)),
  getEpikBoxesByFavorites: (token, online, pagination) =>
    dispatch(getEpikBoxesByFavorites(token, online, pagination)),
  getEpikBoxesByTrackingNumber: (token, trackingNumber, online, pagination) =>
    dispatch(getEpikBoxesByTrackingNumber(token, trackingNumber, online, pagination)),
  getEpikBoxesByMacAddress: (token, macAddress, online, pagination) =>
    dispatch(getEpikBoxesByMacAddress(token, macAddress, online, pagination)),
  getEpikBoxesByStatus: (token, status, online, pagination) =>
    dispatch(getEpikBoxesByStatus(token, status, online, pagination)),
  getEpikBoxesByAssignedNumber: (token, assignedNumber, online, pagination) =>
    dispatch(getEpikBoxesByAssignedNumber(token, assignedNumber, online, pagination)),
  getEpikBoxesByVPNAddress: (token, assignedNumber, pagination) =>
    dispatch(getEpikBoxesByVPNAddress(token, assignedNumber, pagination)),
  getEpikBoxesDataByName: (token, boxName, online, pagination) =>
    dispatch(getEpikBoxesDataByName(token, boxName, online, pagination)),
  getEpikBoxesByAdSearch: (token, params, online, pagination) =>
    dispatch(getEpikBoxesByAdSearch(token, params, online, pagination)),
  addStep: step => dispatch(addStep(step)),
  getBoxCount: (token, companyID) => dispatch(getBoxCount(token, companyID)),
  addNote: (token, id, note) => dispatch(addNote(token, id, note)),
  getNotes: (token, id, pagination) => dispatch(getNotes(token, id, pagination)),
  editNote: (token, box_id, note, note_id) => dispatch(editNote(token, box_id, note, note_id)),
  deleteNote: (token, box_id, note_id) => dispatch(deleteNote(token, box_id, note_id)),
  deleteNoteRecording: (token, noteId) => dispatch(onDeleteRecording(token, noteId)),
  downloadAttachment: (token, note_id, fileName) =>
    dispatch(downloadAttachment(token, note_id, fileName)),
  importEpikBox: (token, number) => dispatch(importEpikBox(token, number)),
  popStep: () => dispatch(popStep()),
  getLocationByCompany: (token, cid) => dispatch(getLocationByCompany(token, cid)),
  getEpikBoxesDataByLocation: (token, locationId, companyId, pagination) =>
    dispatch(getEpikBoxesDataByLocation(token, locationId, companyId, pagination)),
  getEpikUnassignedBoxesData: token => dispatch(getEpikUnassignedBoxesData(token)),
  filteredLocationBoxes: boxes => dispatch(filteredLocationBoxes(boxes)),
  mapLocationsFilter: (token, type, value) => dispatch(mapLocationsFilter(token, type, value)),
  setBoxPagination: options => dispatch(setBoxPagination(options)),
  clearBoxPagination: () => dispatch(clearBoxPagination()),
  sendBulkActionsToApi: () => dispatch(sendBulkActionsToApi()),
  addSystemLogs: (token, body) => dispatch(addSystemLogs(token, body)),
  getEpikBoxesDataBySIM: (token, obiNumber, online, pagination) => dispatch(getEpikBoxesBySIM(token, obiNumber, online, pagination)),
  getEpikBoxesDataByCreated: (token, obiNumber, online, pagination) => dispatch(getEpikBoxesByCreated(token, obiNumber, online, pagination)),
});
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(WithUserData(EpikBoxes));
